import {
  ApiOutlined,
  CloudServerOutlined,
  RobotOutlined,
} from "@ant-design/icons";
import {
  AwsIconUrl,
  AzureIconUrl,
  CopilotStudioIconUrl,
  EntraIdIconUrl,
  GcloudIconUrl,
  GoogleWorkspaceIconUrl,
  K8sIconUrl,
  OktaIconUrl,
} from "@p0security/shared/integrations/constants";
import { AssessmentScopeIntegration } from "@p0security/shared/types/assessment";
import { assertNever } from "@p0security/shared/types/index";
import { Logo } from "components/Integrations/Logo";

export const targetLogo = (integration: AssessmentScopeIntegration) => {
  switch (integration) {
    case "aws":
      return <Logo logo={AwsIconUrl} title="AWS" />;
    case "azure":
      return <Logo logo={AzureIconUrl} title="Azure" />;
    case "gcloud":
      return <Logo logo={GcloudIconUrl} title="Google Cloud" />;
    case "k8s":
      return <Logo logo={K8sIconUrl} title="Kubernetes" />;
    case "workspace":
      return <Logo logo={GoogleWorkspaceIconUrl} title="Google Workspace" />;
    case "okta":
      return <Logo logo={OktaIconUrl} title="Okta" />;
    case "azure-ad":
      return <Logo logo={EntraIdIconUrl} title="Azure AD" />;
    case "entra-id":
      return <Logo logo={EntraIdIconUrl} title="Entra ID" />;
    case "copilot-studio":
      return (
        <Logo logo={CopilotStudioIconUrl} title="Microsoft Copilot Studio" />
      );
    case "custom":
      return <Logo logo={<ApiOutlined />} title="Custom Integration" />;
    case "local-agents":
      return <Logo logo={<RobotOutlined />} title="Local agents" />;
    case "ssh":
      return <Logo logo={<CloudServerOutlined />} title="SSH" />;
    default:
      assertNever(integration);
  }
};
